const notificationsReducerDefaultState = {
    notifications: [],
    systemIds: [],
    invertersYear: [],
    inactiveInverters: []
};

export default (state = notificationsReducerDefaultState, action) => {
    switch (action.type) {
        case 'NOTIFICATIONS_SET':
            return {
                ...state,
                notifications: action.notifications
            };
        case 'SYSTEMIDS_SET':
            return {
                ...state,
                systemIds: action.systemIds
            };
        case 'INVERTERSYEAR_SET':
            return {
                ...state,
                invertersYear: action.invertersYear
        };
        case 'INACTIVE_INVERTERS_SET':
            return {
                ...state,
                inactiveInverters: action.inactiveInverters
        };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/notifications.js